var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeaderImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 960,
    height: 640,
    viewBox: "0 0 960.00004 640.00079",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "r"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "v",
    cx: 1070,
    cy: 700,
    r: 40,
    gradientTransform: "matrix(-1 0 0 1 1830 -99.999)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#q"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: 780,
    x2: 800,
    y1: 373.33,
    y2: 373.33,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#r"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: 410,
    x2: 410,
    y1: 620,
    y2: 640,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#r"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "w",
    cx: 1070,
    cy: 700,
    r: 40,
    gradientTransform: "translate(-1030 -99.999)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#q"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: 780,
    x2: 800,
    y1: 373.33,
    y2: 373.33,
    gradientTransform: "translate(-800)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#r"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 410,
    x2: 410,
    y1: 620,
    y2: 640,
    gradientTransform: "translate(0 -746.67)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#r"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "x",
    cx: 1070,
    cy: 700,
    r: 40,
    gradientTransform: "matrix(-1 0 0 -1 1830 846.67)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#q"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "y",
    cx: 1070,
    cy: 700,
    r: 40,
    gradientTransform: "matrix(1 0 0 -1 -1030 846.67)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#q"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 2050,
    x2: 2560,
    y1: -120,
    y2: -630,
    gradientTransform: "matrix(1 0 0 1.0068 -1e3 4.2185)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "aa",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: "2 2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "z"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "scale(1,-1)",
    y: -1336,
    width: 2000,
    height: 1336,
    ry: 100.2,
    fill: "#d70000"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80 -54.289)"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 -1 1e3 .95523)",
    x: -1000,
    y: -640,
    width: 800,
    height: 533.33,
    ry: 40,
    filter: "url(#aa)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4 0 0 .3992 0 106.67)",
    clipPath: "url(#z)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2000,
    height: 1336,
    fill: "#da251d"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(66.907 0 0 66.907 1e3 706.33)",
    fill: "#ff0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s",
    transform: "translate(0,-6)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "ab",
    transform: "matrix(.95106 .30902 -.30902 .95106 0 0)",
    points: "0 0 0 6 4 6",
    fill: "#ff0"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "scale(-1,1)",
    width: 744.09448,
    height: 1052.3622,
    fill: "#ffff00",
    xlinkHref: "#ab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ac",
    transform: "matrix(.30902 .95106 -.95106 .30902 0 0)"
  }, /*#__PURE__*/React.createElement("use", {
    width: 744.09448,
    height: 1052.3622,
    fill: "#ffff00",
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(.30902 .95106 -.95106 .30902 0 0)",
    width: 744.09448,
    height: 1052.3622,
    fill: "#ffff00",
    xlinkHref: "#s"
  })), /*#__PURE__*/React.createElement("use", {
    transform: "scale(-1,1)",
    width: 744.09448,
    height: 1052.3622,
    fill: "#ffff00",
    xlinkHref: "#ac"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1e3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1e3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m800 600a40 40 0 0 1 -40 40v-20a20 20 0 0 0 20 -20h20z",
    fill: "url(#v)",
    opacity: 0.603
  }), /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 146.67,
    width: 20,
    height: 453.33,
    ry: 0,
    fill: "url(#ad)",
    opacity: 0.603
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 620,
    width: 720,
    height: 20,
    fill: "url(#ae)",
    opacity: 0.603
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 600a40 40 0 0 0 40 40v-20a20 20 0 0 1 -20 -20h-20z",
    fill: "url(#w)",
    opacity: 0.603
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "scale(-1,1)",
    x: -20,
    y: 146.67,
    width: 20,
    height: 453.33,
    ry: 0,
    fill: "url(#af)",
    opacity: 0.603
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "scale(1,-1)",
    x: 40,
    y: -126.67,
    width: 720,
    height: 20,
    fill: "url(#t)",
    opacity: 0.603
  }), /*#__PURE__*/React.createElement("path", {
    d: "m800 146.67a40 40 0 0 0 -40 -40v20a20 20 0 0 1 20 20h20z",
    fill: "url(#x)",
    opacity: 0.603
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 146.67a40 40 0 0 1 40 -40v20a20 20 0 0 0 -20 20h-20z",
    fill: "url(#y)",
    opacity: 0.603
  })), /*#__PURE__*/React.createElement("rect", {
    transform: "scale(1,-1)",
    x: 1020,
    y: -620,
    width: 760,
    height: 493.33,
    ry: 20,
    fill: "url(#u)",
    opacity: 0.3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderImg);
export default __webpack_public_path__ + "static/media/header-img.e32461f047c57321a1a4d733d60eaa45.svg";
export { ForwardRef as ReactComponent };